import type { ReactNode } from 'react';
import styles from './PillLink.module.css';

type PillVariant = 'solid' | 'glass' | 'outline';
type PillSize = 'small' | 'medium' | 'large';

interface PillButtonProps {
    children: ReactNode;
    onClick: () => void;
    variant?: PillVariant;
    size?: PillSize;
    className?: string;
}

export default function PillButton({ children, onClick, variant = 'solid', size = 'medium', className }: PillButtonProps) {
    const classNames = [styles.pill, styles[variant], styles[size], className].filter(Boolean).join(' ');

    return (
        <button type="button" className={classNames} onClick={onClick}>
            <span className={styles.label}>{children}</span>
        </button>
    );
}
